import { render } from "./IconChevronDown.vue?vue&type=template&id=a694b664"
import script from "./IconChevronDown.vue?vue&type=script&lang=js"
export * from "./IconChevronDown.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__